var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPieChartLine = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 13.3333 13.3333",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.66667 0.3052V1.72101C2.71211 2.51219 1.33333 4.42841 1.33333 6.66667C1.33333 9.6122 3.72115 12 6.66667 12C8.90493 12 10.8211 10.6212 11.6123 8.66667H13.0281C12.1786 11.3714 9.65173 13.3333 6.66667 13.3333C2.98477 13.3333 0 10.3485 0 6.66667C0 3.68157 1.96193 1.15471 4.66667 0.3052ZM6.66667 0C10.3485 0 13.3333 2.98477 13.3333 6.66667C13.3333 6.89167 13.3222 7.11407 13.3004 7.33333H6V0.03292C6.21927 0.0111467 6.44167 0 6.66667 0ZM7.33333 1.37459V6H11.9587C11.6579 3.58752 9.7458 1.67543 7.33333 1.37459Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPieChartLine);
export { ForwardRef as ReactComponent };